import { Link, LinkProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledLink = styled<FC<LinkProps>>(Link)`
  margin-left: 26px;
`;
